import * as React from "react";
import classnames from "classnames";
import { Icon } from "@grandvisionhq/icons";
/* empty css             */
import Text from "../../Typography/Text/Typography/Text/Text.js";
const Details = ({
  title,
  subtitle,
  className,
  children,
  summaryAttributes,
  ...rest
}) => {
  const [open, setOpen] = React.useState(false);
  return /* @__PURE__ */ React.createElement(
    "details",
    {
      ...rest,
      open,
      className: classnames("details", className),
      onToggle: () => setOpen(!open)
    },
    /* @__PURE__ */ React.createElement("summary", { ...summaryAttributes, className: "details__summary" }, /* @__PURE__ */ React.createElement("span", { className: "details__icon" }, /* @__PURE__ */ React.createElement(Icon, { width: 18, height: 18, name: open ? "minus" : "plus" })), /* @__PURE__ */ React.createElement(Text, { variant: "body-head", color: "primary" }, title), subtitle && /* @__PURE__ */ React.createElement(Text, { variant: "caption", color: "text-secondary" }, "(", subtitle, ")")),
    /* @__PURE__ */ React.createElement("div", { className: "details__content" }, children)
  );
};
export {
  Details as default
};
//# sourceMappingURL=Details.js.map
